module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.deriveClass
  }, [_c('label', {
    staticClass: "field-title",
    class: {
      'on': _vm.internalValue || _vm.focussed || _vm.placeholder
    }
  }, [_vm._v("\n    " + _vm._s(_vm.displayLabel) + "\n  ")]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.readonly,
      "required": _vm.required
    },
    domProps: {
      "value": _vm.internalValue
    },
    on: {
      "input": function($event) {
        _vm.validate($event.target.value)
      }
    }
  }, _vm._l((_vm.allowedValues), function(option) {
    return _c('option', {
      domProps: {
        "value": option.value || option
      }
    }, [_vm._v("\n      " + _vm._s(option.display_name || option) + "\n    ")])
  })), _vm._v(" "), _c('p', {
    staticClass: "error-msg"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5b5a7f84!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SelectField.vue
// module id = 80
// module chunks = 0